module.exports = __webpack_public_path__ + "static/amazon-logo-fa51399d7074162801b350dd14de551e.jpg";